import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import PageHeader from "../../components/common/PageHeader";
import { useXhr } from "hooks/useXhr";
import { useFounderContext } from "hooks/useFounderContext";
import { Button, Spinner } from "react-bootstrap";
import ReactQuill from 'react-quill';
import Quill from 'quill';
import 'react-quill/dist/quill.snow.css';

function Founder() {
    //States
    const [status, setStatus] = useState(false);
    const [isUpdate, setIsUpdate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [lang, setLang] = useState(null);
    const [error, setError] = useState({
        field: null,
        note: null
    });

    //Hooks
    const { customXhr } = useXhr()
    const { founder, dispatch } = useFounderContext();

    //Quill Config
    const SizeStyle = Quill.import("attributors/style/size");
    SizeStyle.whitelist = ['12px', '14px', '16px', '18px', '24px', '32px', '48px'];
    Quill.register(SizeStyle, true);

    const AlignStyle = Quill.import("attributors/style/align");
    Quill.register(AlignStyle, true);

    const modules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ 'size': ['12px', '14px', '16px', '18px', '24px', '32px', '48px'] }],
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' },
            { 'indent': '-1' }, { 'indent': '+1' }],
            ['link'],
            ['clean'],
            [{ 'color': [] }, { 'background': [] }]
        ]
    }

    //Constants
    const requiredFields = ['alt1', 'alt2', 'alt3', 'alt4', 'text1', 'text2', 'text3', 'text4'];

    //Functions
    const handleOnChange = (e) => {
        const { id, value } = e.target;

        setIsUpdate(prevState => ({
            ...prevState,
            [id]: value
        }));
    };

    const handleTextInput = (e, field) => {
        setIsUpdate(prevState => ({
            ...prevState,
            [field]: e
        }));
    };

    const generateUniqueFileName = (file) => {
        const timestamp = Date.now();
        const randomNumber = Math.floor(Math.random() * 10000);
        const extension = file.name.split('.').pop();

        return `${timestamp}_${randomNumber}.${extension}`;
    };

    const handlePhotoInput = (e) => {
        const file = e.target.files[0];
        const id = e.target.id;

        const newFileName = generateUniqueFileName(file);
        const renamedFile = new File([file], newFileName, { type: file.type });

        setIsUpdate(prevState => ({
            ...prevState,
            [id]: renamedFile
        }));
    };

    const handleSubmit = async () => {
        for (const field of requiredFields) {
            if (!isUpdate[field] || isUpdate[field] === "") {
                return (
                    setError({
                        field: field,
                        note: `Zorunlu alan`
                    }),
                    setIsLoading(false)
                )
            }
        }
        setIsLoading(true);
        const formData = new FormData();
        formData.append('module', 'founder');
        formData.append('action', 'update');
        formData.append('id', isUpdate.id);
        formData.append('firstPhoto', isUpdate.firstPhoto);
        formData.append('secondPhoto', isUpdate.secondPhoto);
        formData.append('thirdPhoto', isUpdate.thirdPhoto);
        formData.append('fourthPhoto', isUpdate.fourthPhoto);
        formData.append('fifthPhoto', isUpdate.fifthPhoto);
        formData.append('sixthPhoto', isUpdate.sixthPhoto);
        formData.append('alt1', isUpdate.alt1);
        formData.append('alt2', isUpdate.alt2);
        formData.append('alt3', isUpdate.alt3);
        formData.append('alt4', isUpdate.alt4);
        formData.append('text1', isUpdate.text1);
        formData.append('textEng1', isUpdate.textEng1);
        formData.append('textFra1', isUpdate.textFra1);
        formData.append('textGer1', isUpdate.textGer1);
        formData.append('textDut1', isUpdate.textDut1);
        formData.append('text2', isUpdate.text2);
        formData.append('textEng2', isUpdate.textEng2);
        formData.append('textFra2', isUpdate.textFra2);
        formData.append('textGer2', isUpdate.textGer2);
        formData.append('textDut2', isUpdate.textDut2);
        formData.append('text3', isUpdate.text3);
        formData.append('textEng3', isUpdate.textEng3);
        formData.append('textFra3', isUpdate.textFra3);
        formData.append('textGer3', isUpdate.textGer3);
        formData.append('textDut3', isUpdate.textDut3);
        formData.append('text4', isUpdate.text4);
        formData.append('textEng4', isUpdate.textEng4);
        formData.append('textFra4', isUpdate.textFra4);
        formData.append('textGer4', isUpdate.textGer4);
        formData.append('textDut4', isUpdate.textDut4);

        const response = await customXhr(formData);

        if (response.status === "success") {
            setIsUpdate(null);
            setLang(null);
            setStatus(!status);
            setError({
                field: null,
                note: null
            });
            setIsLoading(false);
        };
    };

    const getFounder = async () => {
        const formData = new FormData();
        formData.append('module', 'founder');
        formData.append('action', 'list');

        const response = await customXhr(formData);

        if (response) {
            dispatch({ type: 'SET_FOUNDER', payload: response[0] });
        };
    };

    useEffect(() => {
        getFounder();
    }, [status]);

    return (
        <div className="container-xxl">
            <PageHeader headerTitle="Kurucumuz" renderRight={() => {
                return <div className="btn-group" role="group" aria-label="Basic outlined example">
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        title="Türkçe Güncelleme"
                        onClick={() => { setIsUpdate(founder); setLang("tur"); }}
                    >
                        <i className="icofont-edit text-success"></i>
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        title="İngilizce Güncelleme"
                        onClick={() => { setIsUpdate(founder); setLang("eng"); }}
                    >
                        <img src={process.env.PUBLIC_URL + `/flags/united-kingdom.png`} style={{ width: "15px" }} />
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        title="Fransızca Güncelleme"
                        onClick={() => { setIsUpdate(founder); setLang("fra"); }}
                    >
                        <img src={process.env.PUBLIC_URL + `/flags/france.png`} style={{ width: "15px" }} />
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        title="Almanca Güncelleme"
                        onClick={() => { setIsUpdate(founder); setLang("ger"); }}
                    >
                        <img src={process.env.PUBLIC_URL + `/flags/germany.png`} style={{ width: "15px" }} />
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        title="Felemenkçe Güncelleme"
                        onClick={() => { setIsUpdate(founder); setLang("dut"); }}
                    >
                        <img src={process.env.PUBLIC_URL + `/flags/netherlands.png`} style={{ width: "15px" }} />
                    </button>
                </div>
            }} />
            <div className="row align-items-center justify-content-center">
                <div className="col-xxl-10 col-xl-12 col-lg-12 col-md-12 flex-column">
                    {founder &&
                        <>
                            <div className="card d-flex justify-content-center align-items-center">
                                <img src={process.env.PUBLIC_URL + `/uploads/founder/${founder.firstPhotoName}`} style={{
                                    width: "100%",
                                    borderRadius: "8px",
                                    objectFit: "cover"
                                }} />
                            </div>
                            <div className="row mt-4">
                                <div className="col-6 d-flex align-items-center justify-content-center">
                                    <div className="card d-flex justify-content-center align-items-center">
                                        <img src={process.env.PUBLIC_URL + `/uploads/founder/${founder.secondPhotoName}`} style={{
                                            width: "100%",
                                            borderRadius: "8px",
                                            objectFit: "cover"
                                        }} />
                                    </div>
                                </div>
                                <div className="col-6 d-flex align-items-center justify-content-center">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row g-2 pt-4">
                                                <div className="d-flex align-items-center">
                                                    <span className="ms-2" dangerouslySetInnerHTML={{ __html: founder.text1 }} />
                                                </div>
                                            </div>
                                            <div className="row g-2 pt-4">
                                                <div className="col-12">
                                                    <div className="d-flex align-items-center">
                                                        <div className="text-primary">{"SEO 1 => "}</div>
                                                        <span className="ms-2">{founder.alt1}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-6 d-flex align-items-center justify-content-center">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row g-2 pt-4">
                                                <div className="d-flex align-items-center">
                                                    <span className="ms-2" dangerouslySetInnerHTML={{ __html: founder.text2 }} />
                                                </div>
                                            </div>
                                            <div className="row g-2 pt-4">
                                                <div className="col-12">
                                                    <div className="d-flex align-items-center">
                                                        <div className="text-primary">{"SEO 2 => "}</div>
                                                        <span className="ms-2">{founder.alt2}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6 d-flex align-items-center justify-content-center">
                                    <div className="card d-flex justify-content-center align-items-center">
                                        <img src={process.env.PUBLIC_URL + `/uploads/founder/${founder.thirdPhotoName}`} style={{
                                            width: "100%",
                                            borderRadius: "8px",
                                            objectFit: "cover"
                                        }} />
                                    </div>
                                </div>
                            </div>
                            <div className="card d-flex justify-content-center align-items-center mt-4">
                                <img src={process.env.PUBLIC_URL + `/uploads/founder/${founder.fourthPhotoName}`} style={{
                                    width: "100%",
                                    borderRadius: "8px",
                                    objectFit: "cover"
                                }} />
                            </div>
                            <div className="row mt-4">
                                <div className="col-6 d-flex align-items-center justify-content-center">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row g-2 pt-4">
                                                <div className="d-flex align-items-center">
                                                    <span className="ms-2" dangerouslySetInnerHTML={{ __html: founder.text3 }} />
                                                </div>
                                            </div>
                                            <div className="row g-2 pt-4">
                                                <div className="col-12">
                                                    <div className="d-flex align-items-center">
                                                        <div className="text-primary">{"SEO 3 => "}</div>
                                                        <span className="ms-2">{founder.alt3}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6 d-flex align-items-center justify-content-center">
                                    <div className="card d-flex justify-content-center align-items-center">
                                        <img src={process.env.PUBLIC_URL + `/uploads/founder/${founder.fifthPhotoName}`} style={{
                                            width: "100%",
                                            borderRadius: "8px",
                                            objectFit: "cover"
                                        }} />
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-6 d-flex align-items-center justify-content-center">
                                    <div className="card d-flex justify-content-center align-items-center">
                                        <img src={process.env.PUBLIC_URL + `/uploads/founder/${founder.sixthPhotoName}`} style={{
                                            width: "100%",
                                            borderRadius: "8px",
                                            objectFit: "cover"
                                        }} />
                                    </div>
                                </div>
                                <div className="col-6 d-flex align-items-center justify-content-center">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row g-2 pt-4">
                                                <div className="d-flex align-items-center">
                                                    <span className="ms-2" dangerouslySetInnerHTML={{ __html: founder.text4 }} />
                                                </div>
                                            </div>
                                            <div className="row g-2 pt-4">
                                                <div className="col-12">
                                                    <div className="d-flex align-items-center">
                                                        <div className="text-primary">{"SEO 4 => "}</div>
                                                        <span className="ms-2">{founder.alt4}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
            <Modal
                show={lang === "tur"}
                onHide={() => {
                    setIsUpdate(null);
                    setLang(null);
                    setError({
                        field: null,
                        note: null
                    });
                    setIsLoading(false);
                }}
                dialogClassName="modal-xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Kalitenin Reis'i Düzenle</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label htmlFor="text1" className="form-label">
                            {"Yazı 1"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="text1"
                                value={isUpdate.text1}
                                onChange={(e) => handleTextInput(e, "text1")}
                                style={{ borderColor: `${error.field === "text1" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "text1" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                    <div className="mb-3">
                        <label htmlFor="text2" className="form-label">
                            {"Yazı 2"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="text2"
                                value={isUpdate.text2}
                                onChange={(e) => handleTextInput(e, "text2")}
                                style={{ borderColor: `${error.field === "text2" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "text2" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                    <div className="mb-3">
                        <label htmlFor="text3" className="form-label">
                            {"Yazı 3"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="text3"
                                value={isUpdate.text3}
                                onChange={(e) => handleTextInput(e, "text3")}
                                style={{ borderColor: `${error.field === "text3" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "text3" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                    <div className="mb-3">
                        <label htmlFor="text4" className="form-label">
                            {"Yazı 4"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="text4"
                                value={isUpdate.text4}
                                onChange={(e) => handleTextInput(e, "text4")}
                                style={{ borderColor: `${error.field === "text4" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "text4" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                    <div className="mb-3">
                        <div className="row">
                            <div className="col-6">
                                <label htmlFor="alt1" className="form-label">
                                    {"Seo Kelimeler "}
                                    <span className="text-danger">
                                        (Lütfen 5 Kelimeden Fazla Yazmayınız!)
                                    </span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="alt1"
                                    value={isUpdate && isUpdate.alt1}
                                    onChange={handleOnChange}
                                    style={{ borderColor: `${error.field === "alt1" ? "red" : "var(--border-color)"}` }}
                                />
                                {error.field === "alt2" &&
                                    <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                                }
                            </div>
                            <div className="col-6">
                                <label htmlFor="alt2" className="form-label">
                                    {"Seo Kelimeler "}
                                    <span className="text-danger">
                                        (Lütfen 5 Kelimeden Fazla Yazmayınız!)
                                    </span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="alt2"
                                    value={isUpdate && isUpdate.alt2}
                                    onChange={handleOnChange}
                                    style={{ borderColor: `${error.field === "alt2" ? "red" : "var(--border-color)"}` }}
                                />
                                {error.field === "alt2" &&
                                    <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="mb-3">
                        <div className="row">
                            <div className="col-6">
                                <label htmlFor="alt3" className="form-label">
                                    {"Seo Kelimeler "}
                                    <span className="text-danger">
                                        (Lütfen 5 Kelimeden Fazla Yazmayınız!)
                                    </span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="alt3"
                                    value={isUpdate && isUpdate.alt3}
                                    onChange={handleOnChange}
                                    style={{ borderColor: `${error.field === "alt3" ? "red" : "var(--border-color)"}` }}
                                />
                                {error.field === "alt3" &&
                                    <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                                }
                            </div>
                            <div className="col-6">
                                <label htmlFor="alt4" className="form-label">
                                    {"Seo Kelimeler "}
                                    <span className="text-danger">
                                        (Lütfen 5 Kelimeden Fazla Yazmayınız!)
                                    </span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="alt4"
                                    value={isUpdate && isUpdate.alt4}
                                    onChange={handleOnChange}
                                    style={{ borderColor: `${error.field === "alt4" ? "red" : "var(--border-color)"}` }}
                                />
                                {error.field === "alt4" &&
                                    <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="mb-3">
                        <div className="row">
                            <div className="col-6">
                                <label htmlFor="firstPhoto" className="form-label">
                                    {"1.Fotoğraf Yükle"}
                                </label>
                                <input
                                    className="form-control"
                                    type="file"
                                    id="firstPhoto"
                                    onChange={handlePhotoInput}
                                />
                                <div className="form-label" style={{ color: "red" }}>
                                    {"Bu alanın geçerli görsel öğe boyutu: 3600x600"}
                                </div>
                            </div>
                            <div className="col-6">
                                <label htmlFor="secondPhoto" className="form-label">
                                    {"2.Fotoğraf Yükle"}
                                </label>
                                <input
                                    className="form-control"
                                    type="file"
                                    id="secondPhoto"
                                    onChange={handlePhotoInput}
                                />
                                <div className="form-label" style={{ color: "red" }}>
                                    {"Bu alanın geçerli görsel öğe boyutu: 1500x1200"}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mb-3">
                        <div className="row">
                            <div className="col-6">
                                <label htmlFor="thirdPhoto" className="form-label">
                                    {"3.Fotoğraf Yükle"}
                                </label>
                                <input
                                    className="form-control"
                                    type="file"
                                    id="thirdPhoto"
                                    onChange={handlePhotoInput}
                                />
                                <div className="form-label" style={{ color: "red" }}>
                                    {"Bu alanın geçerli görsel öğe boyutu: 1500x1200"}
                                </div>
                            </div>
                            <div className="col-6">
                                <label htmlFor="fourthPhoto" className="form-label">
                                    {"4.Fotoğraf Yükle"}
                                </label>
                                <input
                                    className="form-control"
                                    type="file"
                                    id="fourthPhoto"
                                    onChange={handlePhotoInput}
                                />
                                <div className="form-label" style={{ color: "red" }}>
                                    {"Bu alanın geçerli görsel öğe boyutu: 3600x1500"}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mb-3">
                        <div className="row">
                            <div className="col-6">
                                <label htmlFor="fifthPhoto" className="form-label">
                                    {"5.Fotoğraf Yükle"}
                                </label>
                                <input
                                    className="form-control"
                                    type="file"
                                    id="fifthPhoto"
                                    onChange={handlePhotoInput}
                                />
                                <div className="form-label" style={{ color: "red" }}>
                                    {"Bu alanın geçerli görsel öğe boyutu: 1500x1200"}
                                </div>
                            </div>
                            <div className="col-6">
                                <label htmlFor="sixthPhoto" className="form-label">
                                    {"6.Fotoğraf Yükle"}
                                </label>
                                <input
                                    className="form-control"
                                    type="file"
                                    id="sixthPhoto"
                                    onChange={handlePhotoInput}
                                />
                                <div className="form-label" style={{ color: "red" }}>
                                    {"Bu alanın geçerli görsel öğe boyutu: 1500x1200"}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        className="me-1"
                        onClick={() => handleSubmit()}
                        disabled={isLoading}
                    >
                        {
                            isLoading ?
                                <>
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />
                                    Yükleniyor...
                                </> :
                                <>
                                    Kaydet
                                </>
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={lang === "eng"}
                onHide={() => {
                    setIsUpdate(null);
                    setLang(null);
                    setError({
                        field: null,
                        note: null
                    });
                    setIsLoading(false);
                }}
                dialogClassName="modal-xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">İngilizce Düzenle</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label htmlFor="textEng1" className="form-label">
                            {"Yazı 1"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textEng1"
                                value={isUpdate.textEng1}
                                onChange={(e) => handleTextInput(e, "textEng1")}
                                style={{ borderColor: `${error.field === "textEng1" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textEng1" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                    <div className="mb-3">
                        <label htmlFor="textEng2" className="form-label">
                            {"Yazı 2"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textEng2"
                                value={isUpdate.textEng2}
                                onChange={(e) => handleTextInput(e, "textEng2")}
                                style={{ borderColor: `${error.field === "textEng2" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textEng2" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                    <div className="mb-3">
                        <label htmlFor="textEng3" className="form-label">
                            {"Yazı 3"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textEng3"
                                value={isUpdate.textEng3}
                                onChange={(e) => handleTextInput(e, "textEng3")}
                                style={{ borderColor: `${error.field === "textEng3" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textEng3" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                    <div className="mb-3">
                        <label htmlFor="textEng4" className="form-label">
                            {"Yazı 4"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textEng4"
                                value={isUpdate.textEng4}
                                onChange={(e) => handleTextInput(e, "textEng4")}
                                style={{ borderColor: `${error.field === "textEng4" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textEng4" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        className="me-1"
                        onClick={() => handleSubmit()}
                        disabled={isLoading}
                    >
                        {
                            isLoading ?
                                <>
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />
                                    Yükleniyor...
                                </> :
                                <>
                                    Kaydet
                                </>
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={lang === "fra"}
                onHide={() => {
                    setIsUpdate(null);
                    setLang(null);
                    setError({
                        field: null,
                        note: null
                    });
                    setIsLoading(false);
                }}
                dialogClassName="modal-xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Fransızca Düzenle</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label htmlFor="textFra1" className="form-label">
                            {"Yazı 1"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textFra1"
                                value={isUpdate.textFra1}
                                onChange={(e) => handleTextInput(e, "textFra1")}
                                style={{ borderColor: `${error.field === "textFra1" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textFra1" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                    <div className="mb-3">
                        <label htmlFor="textFra2" className="form-label">
                            {"Yazı 2"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textFra2"
                                value={isUpdate.textFra2}
                                onChange={(e) => handleTextInput(e, "textFra2")}
                                style={{ borderColor: `${error.field === "textFra2" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textFra2" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                    <div className="mb-3">
                        <label htmlFor="textFra3" className="form-label">
                            {"Yazı 3"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textFra3"
                                value={isUpdate.textFra3}
                                onChange={(e) => handleTextInput(e, "textFra3")}
                                style={{ borderColor: `${error.field === "textFra3" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textFra3" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                    <div className="mb-3">
                        <label htmlFor="textFra4" className="form-label">
                            {"Yazı 4"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textFra4"
                                value={isUpdate.textFra4}
                                onChange={(e) => handleTextInput(e, "textFra4")}
                                style={{ borderColor: `${error.field === "textFra4" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textFra4" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        className="me-1"
                        onClick={() => handleSubmit()}
                        disabled={isLoading}
                    >
                        {
                            isLoading ?
                                <>
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />
                                    Yükleniyor...
                                </> :
                                <>
                                    Kaydet
                                </>
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={lang === "ger"}
                onHide={() => {
                    setIsUpdate(null);
                    setLang(null);
                    setError({
                        field: null,
                        note: null
                    });
                    setIsLoading(false);
                }}
                dialogClassName="modal-xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Almanca Düzenle</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label htmlFor="textGer1" className="form-label">
                            {"Yazı 1"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textGer1"
                                value={isUpdate.textGer1}
                                onChange={(e) => handleTextInput(e, "textGer1")}
                                style={{ borderColor: `${error.field === "textGer1" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textGer1" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                    <div className="mb-3">
                        <label htmlFor="textGer2" className="form-label">
                            {"Yazı 2"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textGer2"
                                value={isUpdate.textGer2}
                                onChange={(e) => handleTextInput(e, "textGer2")}
                                style={{ borderColor: `${error.field === "textGer2" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textGer2" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                    <div className="mb-3">
                        <label htmlFor="textGer3" className="form-label">
                            {"Yazı 3"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textGer3"
                                value={isUpdate.textGer3}
                                onChange={(e) => handleTextInput(e, "textGer3")}
                                style={{ borderColor: `${error.field === "textGer3" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textGer3" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                    <div className="mb-3">
                        <label htmlFor="textGer4" className="form-label">
                            {"Yazı 4"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textGer4"
                                value={isUpdate.textGer4}
                                onChange={(e) => handleTextInput(e, "textGer4")}
                                style={{ borderColor: `${error.field === "textGer4" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textGer4" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        className="me-1"
                        onClick={() => handleSubmit()}
                        disabled={isLoading}
                    >
                        {
                            isLoading ?
                                <>
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />
                                    Yükleniyor...
                                </> :
                                <>
                                    Kaydet
                                </>
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={lang === "dut"}
                onHide={() => {
                    setIsUpdate(null);
                    setLang(null);
                    setError({
                        field: null,
                        note: null
                    });
                    setIsLoading(false);
                }}
                dialogClassName="modal-xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Felemenkçe Düzenle</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label htmlFor="textDut1" className="form-label">
                            {"Yazı 1"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textDut1"
                                value={isUpdate.textDut1}
                                onChange={(e) => handleTextInput(e, "textDut1")}
                                style={{ borderColor: `${error.field === "textDut1" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textDut1" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                    <div className="mb-3">
                        <label htmlFor="textDut2" className="form-label">
                            {"Yazı 2"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textDut2"
                                value={isUpdate.textDut2}
                                onChange={(e) => handleTextInput(e, "textDut2")}
                                style={{ borderColor: `${error.field === "textDut2" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textDut2" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                    <div className="mb-3">
                        <label htmlFor="textDut3" className="form-label">
                            {"Yazı 3"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textDut3"
                                value={isUpdate.textDut3}
                                onChange={(e) => handleTextInput(e, "textDut3")}
                                style={{ borderColor: `${error.field === "textDut3" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textDut3" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                    <div className="mb-3">
                        <label htmlFor="textDut4" className="form-label">
                            {"Yazı 4"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textDut4"
                                value={isUpdate.textDut4}
                                onChange={(e) => handleTextInput(e, "textDut4")}
                                style={{ borderColor: `${error.field === "textDut4" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textDut4" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        className="me-1"
                        onClick={() => handleSubmit()}
                        disabled={isLoading}
                    >
                        {
                            isLoading ?
                                <>
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />
                                    Yükleniyor...
                                </> :
                                <>
                                    Kaydet
                                </>
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Founder;